import { Injectable } from '@angular/core';
import { SQSClient, SendMessageCommand, SendMessageCommandInput, SendMessageCommandOutput, SQSClientConfig } from '@aws-sdk/client-sqs';
import * as _ from 'lodash';
import * as Constants from '../models/Constants';
import { RootScopeService } from './root-scope.service';
import { InteractionEventDTO } from '../models/InteractionEventDTO';
import { Global } from '../global/globalApi';

@Injectable({
  providedIn: 'root',
})
export class AwsSqsService {
  className: string = 'AwsSqsService';
  /***
   * This service is mainly created for
   * communicating with AWS Queue and sending logs/data to AWS Queue
   * @author : Pooja Gupta
   * 
   * Version aws-sdk v2 updated to V3
   * CCR1-14283
   */
  queueUrl: any;
  interactionQueueObj: any;
  private ihSqsClient: SQSClient | null = null;
  private logsSqsClient: SQSClient | null = null;
  constructor(public rootScope: RootScopeService) { }

  private createSqsClient(configObj: any): SQSClient | null {
    const region = configObj?.region;
    if (!region) {
      console.warn('AwsSqsService: SQSClient not created – region is missing in config');
      return null;
    }
    const credentials = configObj?.credentials;
    const clientConfig: SQSClientConfig = {
      region,
    };

    if (credentials?.accessKeyId && credentials?.secretAccessKey) {
      clientConfig.credentials = {
        accessKeyId: credentials.accessKeyId,
        secretAccessKey: credentials.secretAccessKey,
      };
    }

    return new SQSClient(clientConfig);
  }

  private getIhSqsClient(): SQSClient | null {
    if (!this.ihSqsClient) {
      this.ihSqsClient = this.createSqsClient(this.rootScope.IH_config);
    }
    return this.ihSqsClient;
  }

  private getLogSqsClient(): SQSClient | null {
    if (!this.logsSqsClient) {
      this.logsSqsClient = this.createSqsClient(this.rootScope.log_config);
    }
    return this.logsSqsClient;
  }
  /**
   * Below method fetches out
   * aws related credentials and queue
   * data from appConfigObj and set in AWS config Obje
   */
  getAWSConfigObj() {
    try {

      let accessKeyObj = this.rootScope.getObjFromConfigObj(
        Constants.AWS_SECRET_IH_KEY
      );
      let accessKeyIdObj = this.rootScope.getObjFromConfigObj(
        Constants.AWS_SECRET_IH_KEY_ID
      );
      let regionObj = this.rootScope.getObjFromConfigObj(Constants.IH_SQS_REGION);
     
      this.interactionQueueObj =
        this.rootScope.getObjFromConfigObj(Constants.IH_SQS_QUEUE_URL);
     
      let queueUrlObj = this.rootScope.getObjFromConfigObj(
        Constants.IH_SQS_QUEUE_URL
      );
      let config = {
        accessKeyId: accessKeyIdObj?.['fieldValue'],
        secretAccessKey: accessKeyObj?.['fieldValue'],
        region: 'region=' + regionObj?.['fieldValue'] + '#',
      };
      console.log('AWS config Obj', config);
      this.rootScope.IH_config = {
        credentials: config,
        region: regionObj?.['fieldValue'],
      };
      // this.connectToAWSSQS(config, regionObj['fieldValue']);
      this.queueUrl = queueUrlObj?.['fieldValue'];
    } catch (e) {
      console.log('Error in fetching queue service', e);
    }
  }

  /**
   * @param :config = AWS credentials Object
   * region : "US-EAST#" .Below method is used to make connectivity
   * to amazon aws sqs using aws credentials and details
   */
  connectToAWSSQS(config: { accessKeyId?: string; secretAccessKey?: string }, region: string) {
    this.rootScope.IH_config = {
      credentials: config,
      region: region,
    };
    this.ihSqsClient = this.createSqsClient(this.rootScope.IH_config);
  }

  loadAWSconfigForAngularLogs() {
    let regionObj = this.rootScope.getObjFromConfigObj(Constants.IH_SQS_REGION);

    let accessKeyObj = this.rootScope.getObjFromConfigObj(
      Constants.LOG_SQS_ACCESS_ID
    );
    let secretKeyObj = this.rootScope.getObjFromConfigObj(
      Constants.LOG_SECR_KEY 
    );


    let config = {
      accessKeyId: accessKeyObj?.['fieldValue'],
      secretAccessKey: secretKeyObj?.['fieldValue'],
      region: 'region=' + regionObj?.['fieldValue'] + '#',
    };

    this.rootScope.log_config = {
      credentials: config,
      region: regionObj?.['fieldValue'],
    };
    this.logsSqsClient = this.createSqsClient(this.rootScope.log_config);

    console.log('AWS Log_config' + JSON.stringify(this.rootScope.log_config));

    console.log('Angular AWS config ' + JSON.stringify(config));

  }

  /**
   * sending msgs to SQS QUEUE
   */
  sendLogsToSQSQueue() {
    let params = this.createSQSQueueMsg();
    this.sendDataToSQS(params);
  }

  sendDataToSQS(data: SendMessageCommandInput) {
    let sqs = this.getIhSqsClient();
    if (!sqs) { return; }
    sqs
      .send(new SendMessageCommand(data as SendMessageCommandInput))
      .then((response: SendMessageCommandOutput) => {
        this.rootScope.triggerLog(
          'Message succesfully sent to SQS' + JSON.stringify(response.MessageId),
          this.className,
          Constants.DEBUG
        );
        console.log('Message succesfully sent to SQS', response.MessageId);
      })
      .catch((err: any) => {
        this.rootScope.triggerLog('Error in sending message to SQS = ' + JSON.stringify(err), this.className);
        console.log('Error in sending message to SQS', err);
      });
  }

  async sendAngularLogsToSQS(data: any) {
    let queueUrl = '';
    let logSQSurl = this.rootScope.getObjFromConfigObj(
      Constants.LOG_SQS_URL
    );

    if (logSQSurl) {
      queueUrl = logSQSurl['fieldValue'];
    }

    let logMsgObj = this.createAngularLogsSQSqueueMessage(data, queueUrl);
    console.log('Angular logMsgObj ' + JSON.stringify(logMsgObj));
    this.sendAngularDataToSQS(logMsgObj);
  }


  sendAngularDataToSQS(data: SendMessageCommandInput) {
    setTimeout(() => {
      let sqs = this.getLogSqsClient();
      if (!sqs) { return; }
      sqs
        .send(new SendMessageCommand(data as SendMessageCommandInput))
        .then((response: SendMessageCommandOutput) => {
          this.rootScope.triggerLog(
            'Angular AWS Message succesfully sent to SQS' + JSON.stringify(response.MessageId),
            this.className,
            Constants.DEBUG
          );
        })
        .catch((err: any) => {
          this.rootScope.triggerLog('Error in sending message to SQS = ' + JSON.stringify(err), this.className);
          console.log('Error in sending message to SQS', err);
        });
    }, 100);


  }

  /**
   * Below method used for testing purpose whether config object properly set
   * \in AWS or nnot
   */
  checkAWSCredentialsConfigObj() {
    const credentials = this.rootScope?.IH_config?.credentials;
    if (!credentials?.accessKeyId || !credentials?.secretAccessKey) {
      console.log('AWS credentials are not configured in IH_config');
    }
  }

  createSQSQueueMsg() {
    return {
      DelaySeconds: 10,
      MessageAttributes: {
        'event-type': {
          DataType: 'String',
          StringValue: 'debug',
        },
        'application-type': {
          DataType: 'String',
          StringValue: 'awcp-angular',
        },
        'session-id': {
          DataType: 'String',
          StringValue: this.rootScope.sessionId,
        },
        'user-id': {
          DataType: 'String',
          StringValue: this.rootScope.userName,
        },
        'module-type': {
          DataType: 'String',
          StringValue: 'telephony',
        },
        'message-content': {
          DataType: 'String',
          StringValue: 'abcd',
        },
        'message-description': {
          DataType: 'String',
          StringValue: 'abcd',
        },
      },
      MessageBody: 'Pushing logs to SQS Queue',
      QueueUrl: this.queueUrl,
    };
  }

  createInteractionSQSQueueMsg(msgObj: InteractionEventDTO, queUrl: string) {
    //console.log('INTERACTION SQS URL: ' + queUrl);
    return {
      MessageAttributes: {
        'event-type': {
          DataType: 'String',
          StringValue: 'debug',
        },
        'application-type': {
          DataType: 'String',
          StringValue: 'awcp-angular',
        },
        'session-id': {
          DataType: 'String',
          StringValue: this.rootScope.sessionId,
        },
        'user-id': {
          DataType: 'String',
          StringValue: this.rootScope.userName,
        },
        'module-type': {
          DataType: 'String',
          StringValue: 'telephony',
        },

        agentId: {
          DataType: 'String',
          StringValue: msgObj.agentId,
        },
      },
      MessageBody: JSON.stringify(msgObj),
      // MessageDeduplicationId: new Date().getTime().toString(),
      // MessageGroupId: new Date().getTime().toString(),
      QueueUrl: queUrl,
    };
  }

  sendInteractionEventToSQS(interactionEventObj: InteractionEventDTO) {
    if (this.interactionQueueObj === undefined) {
      // console.log('sqsUrlObj for Interaction queue is Undefined');
      return;
    }
    let msgObj = this.createInteractionSQSQueueMsg(
      interactionEventObj,
      this.interactionQueueObj['fieldValue']
    );
    this.sendDataToSQS(msgObj);
  }

  sendInteractionHistoryToSQS(InteractionDTO: any) {
    let historyDtObj = {
      MessageAttributes: {
        'event-type': {
          DataType: 'String',
          StringValue: 'debug',
        },
        'application-type': {
          DataType: 'String',
          StringValue: 'awcp-angular',
        },
        'session-id': {
          DataType: 'String',
          StringValue: this.rootScope.sessionId,
        },
        'user-id': {
          DataType: 'String',
          StringValue: this.rootScope.userName,
        },
        'module-type': {
          DataType: 'String',
          StringValue: 'telephony',
        },

        // 'agentId': {
        //   DataType: 'String',
        //   StringValue: msgObj.agentId,
        // }
      },
      MessageBody: JSON.stringify(InteractionDTO),
      // MessageDeduplicationId: new Date().getTime().toString(),
      // MessageGroupId: new Date().getTime().toString(),
      QueueUrl: this.interactionQueueObj?.['fieldValue'],
    };

    this.sendDataToSQS(historyDtObj);
  }

  getCurrentEnv() {
    let apiUrl = `${Global.domainUrl}`;
    // console.log('getCurrentEnv apiUrl: ' + apiUrl);
    if (apiUrl?.indexOf('dv') != -1) {
      return 'DV';
    } else {
      return 'QA';
    }
  }




  createAngularLogsSQSqueueMessage(msgObj: any, queUrl: string) {
    //console.log('INTERACTION SQS URL: ' + queUrl);
    return {
      MessageAttributes: {
        'event-type': {
          DataType: 'String',
          StringValue: 'debug',
        },
        'application-type': {
          DataType: 'String',
          StringValue: 'awcp-angular',
        },
        'session-id': {
          DataType: 'String',
          StringValue: this.rootScope.sessionId,
        },
        'user-id': {
          DataType: 'String',
          StringValue: this.rootScope.userName,
        },
        'module-type': {
          DataType: 'String',
          StringValue: 'telephony',
        },

        'agentId': {
          DataType: 'String',
          StringValue: this.rootScope.lanId
        },
        'action': {
          DataType: 'String',
          StringValue: 'sendMessage'
        }
      },
      MessageBody: JSON.stringify(msgObj),
      // MessageDeduplicationId: new Date().getTime().toString(),
      // MessageGroupId: new Date().getTime().toString(),
      QueueUrl: queUrl,
    };
  }
  
}
